<template>
  <div class="editor-audio">
    <p class="editor-text">Replace asset</p>
    <DropZone
      class="uploader"
      :progress-total="total"
      :progress-loaded="loaded"
      :fileName="node.fileName"
      :mediaLink="node.mediaLink"
      @file-drop="handleFileDrop"
      @clear-changes="clearAllChanges"
      audioType
      data-test="audio-editor-dropzone"
    ></DropZone>
  </div>
</template>

<script>
import DropZone from "@/components/DropZone.vue";
import { useUploadToS3 } from "@/helper/uploadToS3Composable.js";
import { useBuilderStore } from "@/stores/builderStore";

export default {
  name: "AudioEditor",
  components: {
    DropZone,
  },
  props: {
    node: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    loaded: null,
    total: null,
  }),
  computed: {
    builderStore() {
      return useBuilderStore();
    }
  },
  methods: {
    handleFileDrop(file) {
      const { loaded, total, request } = useUploadToS3(
        file,
        import.meta.env.VITE_APP_CUSTOM_CONTENT_URL,
        import.meta.env.VITE_APP_MEDIA_UPLOAD_ENDPOINT
      );
      this.loaded = loaded;
      this.total = total;
      request.then((link) => {
        this.mediaLink = link;
        this.builderStore.updateNodeValue({
          node: this.node,
          data: {
            val: link,
            mediaLink: link,
            fileName: file.name
          },
        });
        this.$emit("preview");
      });
    },
    clearAllChanges() {
      this.loaded = this.total = null;
      this.builderStore.undoNodeChanges();
      this.$emit("preview", true);
    },
  },
};
</script>

<style lang="scss" scoped>
.editor-audio {
  margin-top: 27px;

  .editor-text {
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    color: #07354a;
  }
  .uploader {
    margin-top: 24px;
  }
}
</style>
